import { LIMIT } from '@authority-labs/constants';
import { QueryFilter, QueryJoin } from '@nestjsx/crud-request';

export interface SearchRequestInt {
  value: string | number;
  searchFields: string[];
  selectFields?: string[];
  page?: number;
  limit?: number;
  joinFields?: QueryJoin[];
  filters?: Array<QueryFilter>;
}

export class SearchRequest {
  value: string | number;
  searchFields: string[];
  selectFields?: string[];
  page?: number;
  limit?: number;
  joinFields?: QueryJoin[];
  filters?: QueryFilter[];

  constructor(searchResult: SearchRequestInt) {
    this.value = searchResult.value;
    this.searchFields = searchResult.searchFields;
    this.selectFields = searchResult.selectFields || [];
    this.page = searchResult.page || 1;
    this.limit = searchResult.limit || LIMIT.SEARCH_LIMIT;
    this.joinFields = searchResult.joinFields || [];
    this.filters = searchResult.filters || [];
  }
}
